import Vue from "vue";
import VueRouter from "vue-router";
import Radingcenter from "@/views/financial/Radingcenter";
import Transaction from "@/views/financial/Transaction";

Vue.use(VueRouter);

export default [
  {
    meta: {
      title: "交易中心"
    },
    path: "radingcenter", //交易中心
    name: "Radingcenter",
    component: Radingcenter

  },
  {
    meta: {
      title: "交易明细"
    },
    path: "transaction/:applyNo", //交易明细
    name: "Transaction",
    component: Transaction
  }
]